import { render, staticRenderFns } from "./SystemNotificationsListView.vue?vue&type=template&id=3187c062&scoped=true&"
import script from "./SystemNotificationsListView.vue?vue&type=script&lang=ts&"
export * from "./SystemNotificationsListView.vue?vue&type=script&lang=ts&"
import style0 from "./SystemNotificationsListView.vue?vue&type=style&index=0&id=3187c062&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187c062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
